import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from 'js-cookie';

export const dashboardApi = createApi({
    reducerPath: "dashboardApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BASE_URL}`,
        prepareHeaders: (headers, { getState }) => {
            const { auth } = getState();
            const token = auth.user.token
            headers.set('Authorization', `Bearer ${token}`);
            headers.set('Content-Type', `application/json;charset=UTF-8`);
            return headers;
        },
    }),
    tagTypes: ["ManageUser"],
    endpoints: (builder) => ({
        tilesData: builder.query({
            query: (data) => {
                return {
                    url: "/Auth/tileData",
                    method: "GET",
                    params: data
                }
            },
            providesTags: ["ManageUser"],
        })
    }),
});

export const {useTilesDataQuery} = dashboardApi;
